export default {
  props: {
    headerNavigation: {
      type: String,
      default: 'previous',
    },
  },
  methods: {
    getHeaderLabel(header) {
      return header.label || this.$t(header.labelPath);
    },
    getHeaderDetail(header) {
      return header.detail || this.$t(header.detailPath);
    },
    headerStepClass(index) {
      return {
        'future-step': index > this.step,
      };
    },
    headerStepVariant(index) {
      return index <= this.step ? 'primary' : 'secondary';
    },
    stepClass(index) {
      return { 'active-step': index === this.step, 'visited-step': index < this.step };
    },
    canNavigateByHeaderTo(step) {
      const stepHandler = step < this.step;
      const statusTypes = {
        disabled: false,
        full: true,
        previous: stepHandler,
      };
      return statusTypes[this.headerNavigation];
    },
    canGoToStepByHeader(step) {
      return step !== this.step
        && this.canNavigateByHeaderTo(step)
        && this.isStepEnabled(step);
    },
  },
};
